import { render, staticRenderFns } from "./InfoScene.vue?vue&type=template&id=2ed5d610&scoped=true&"
import script from "./InfoScene.vue?vue&type=script&lang=js&"
export * from "./InfoScene.vue?vue&type=script&lang=js&"
import style0 from "./InfoScene.vue?vue&type=style&index=0&id=2ed5d610&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2ed5d610",
  null
  
)

export default component.exports